import {
  CAMPAIGN_AUDIENCE,
  ASSET_AUDIENCE,
  PEOPLE_AUDIENCE,
  AUDIENCE_CONTACT_DETAILS,
  AUDIENCE_CONTACT_DASHBOARD,
  AUDIENCE_CONTACT_SUBSCRIPTIONS,
  RECOMMENDED_PEOPLE_SEARCH,
  RECOMMENDED_LIST_SEARCH,
  AUDIENCE_CONTACT_ENGAGEMENT,
  AUDIENCE_CONTACT_SIMILAR,
  AUDIENCE_REMOVE_RECOMMENDED,
  AUDIENCE_REMOVE_SUBSCRIBED,
  SUGGESTED_EMAILS,
  VIEW_RECIPIENTS,
  AUDIENCE_PEOPLE,
} from 'constants/actionTypes';
import { GLOBAL_ACTION } from 'modules/GlobalActions';
import * as Interfaces from './interface';
import { removeProfiledFromUnprofiled } from './Lists/actions';

const audienceInitialState = {
  data: {
    lists: Array<Interfaces.IListItem>(),
    contacts: Array<Interfaces.IContactItem>(),
  } as Interfaces.IAudienceItem,
  lists_loading: false,
  contacts_loading: false,
  showDetailProfile: false,
  showCreateContactForm: false,
  importListAsider: false,
  editContactPopup: false,
  linkAsider: false,
  showFilterToggle: false,
};

const assetAudienceInitialState: any = {
  data: {
    lists: Array<Interfaces.IListItem>(),
    contacts: Array<Interfaces.IContactItem>(),
    recipientContacts: Array<Interfaces.IContactItem>(),
  } as Interfaces.IAudienceItem,
  totalContacts: 0,
  lists_loading: false,
  contacts_loading: false,
  loadAllContacts: false,
  page: 0,
  hasMore: true,
  pageSearch: 0,
  hasMoreSearch: true,
  success: true,
  message: '',
};

const peopleAudienceInitialState = {
  allPeopleLoading: false,
  success: true,
  message: '',
  profiledPeopleloading: false,
  unprofiledPeopleloading: false,
  allPeople: Array<Interfaces.IPeopleItem>(),
  profiledPeople: Array<Interfaces.IPeopleItem>(),
  nonprofiledPeople: Array<Interfaces.IPeopleItem>(),
  allPeoplePage: 0,
  profilePage: 0,
  allPeoplePagePagination: true,
  profilePagePagination: true,
  unprofiledPage: 0,
  unprofiledPagePagination: true,
  newlyAddedContact: '',
  deleteLoading: false,
  deleteSuccess: false,
  contactDetails: {} as Interfaces.IContactDetails,
  createNewContactLoading: false,
  createNewContactStatus: false,
  contactDashboard: {} as Interfaces.IContactDashboard,
  contactSubscriptions: {} as Interfaces.IContactSubscriptions,
  uiUpdateCheck: false,
  contactEngagement: {},
  contactSimilar: {},
  searchTermPeople: '',
  removeProfiledFromUnprofiled: false,
  removeUnprofiledFromProfiled: false,
  reloadContacts: false,
  peopleUiRerenderCheck: false,
  updateContactInProgress: false,
  contactUpdatedSuccessfully: false,
  contactUpdateFailed: false,
  openEditContactSidebar: false,
  selectedPersonalityTypes: [],
  totalCount: 0,
  totalCountWithoutList: 0,
  organizations: <any>[],
  designations: <any>[],
  organizationsLoading: false,
  designationsLoading: false,
  peopleAudienceFilters: {},
  filters: {
    designations: [],
    organizations: [],
    personality: [],
    status: [],
    buyerStage: [],
  },
  contactUpdatedInPeopleAudience: false,
  currentActiveList: '',
};
const searchRecommendedPeopleInitialState = {
  data: Array<Interfaces.IContactItem>(),
  totalSearchedContacts: 0,
  suggestedContacts: [],
  loading: false,
  success: true,
  message: '',
};

const searchRecommendedListInitialState = {
  data: Array<Interfaces.IListItem>(),
  totalLists: 0,
  loading: false,
  success: true,
  message: '',
};

export const audienceReducer = (state = audienceInitialState, action: Interfaces.IAudienceAction) => {
  const newState = { ...state };
  switch (action.type) {
    case GLOBAL_ACTION.OPEN_DETAIL_PROFILE:
      newState.showDetailProfile = true;
      return newState;
    case GLOBAL_ACTION.CLOSE_DETAIL_PROFILE:
      newState.showDetailProfile = false;
      return newState;

    case GLOBAL_ACTION.OPEN_CREATE_CONTACT_FORM:
      newState.showCreateContactForm = true;
      return newState;
    case GLOBAL_ACTION.IMPORT_LIST_POPOVER:
      const { importListAsiderState } = action.payload;
      newState.importListAsider = importListAsiderState;
      return newState;
    case GLOBAL_ACTION.CLOSE_CREATE_CONTACT_FORM:
      newState.showCreateContactForm = false;
      return newState;

    // actions related to campaign lists
    case CAMPAIGN_AUDIENCE.LISTS_LOAD:
      newState.lists_loading = true;
      return newState;
    case CAMPAIGN_AUDIENCE.LISTS_SUCCESS:
      newState.lists_loading = false;
      newState.data.lists = [...newState.data.lists, ...action.payload.lists];
      return newState;
    case CAMPAIGN_AUDIENCE.LISTS_FAIL:
      newState.lists_loading = false;
      return newState;

    // actions related to campaign contacts
    case CAMPAIGN_AUDIENCE.CONTACTS_LOAD:
      newState.contacts_loading = true;
      return newState;
    case CAMPAIGN_AUDIENCE.CONTACTS_SUCCESS:
      newState.contacts_loading = false;
      newState.data.contacts = [...newState.data.contacts, ...action.payload.contacts];
      return newState;
    case CAMPAIGN_AUDIENCE.CONTACTS_FAIL:
      newState.contacts_loading = false;
      return newState;

    case CAMPAIGN_AUDIENCE.LINK_AUDIENCE_CAMPAIGN_SUCCESS:
      newState.lists_loading = false;
      newState.contacts_loading = false;
      newState.data.lists = [...action.payload.lists];
      newState.data.contacts = [...state.data.contacts, ...action.payload.contacts];
      return newState;

    case CAMPAIGN_AUDIENCE.SET_LIST:
      newState.lists_loading = false;
      newState.contacts_loading = false;
      newState.data.lists = [...action.payload.lists];
      return newState;

    case CAMPAIGN_AUDIENCE.SET_EDIT_CONTACT_POPOVER_STATE:
      newState.editContactPopup = action.payload.editContactPopup;
      return newState;

    case CAMPAIGN_AUDIENCE.SET_LINK_ASIDER_STATE:
      newState.linkAsider = action.linkAsider;
      return newState;

    case PEOPLE_AUDIENCE.AUDIENCE_FILTER_TOGGLE:
      newState.showFilterToggle = action.showFilterToggle;
      return newState;

    case CAMPAIGN_AUDIENCE.RESET:
      const defaultState = {
        data: {
          lists: Array<Interfaces.IListItem>(),
          contacts: Array<Interfaces.IContactItem>(),
        } as Interfaces.IAudienceItem,
        lists_loading: false,
        contacts_loading: false,
        showDetailProfile: false,
        showCreateContactForm: false,
        importListAsider: false,
        editContactPopup: false,
        linkAsider: false,
        showFilterToggle: false,
      };
      return defaultState;

    default:
      return state;
  }
};

export const assetAudienceReducer = (state = assetAudienceInitialState, action: Interfaces.IAudienceAction) => {
  const newState = { ...state };
  switch (action.type) {
    // actions related to asset lists
    case ASSET_AUDIENCE.LISTS_LOAD:
      newState.lists_loading = true;
      return newState;
    case ASSET_AUDIENCE.LISTS_SUCCESS:
      newState.lists_loading = false;
      newState.data.lists = [...action.payload.lists];
      return newState;
    case ASSET_AUDIENCE.LISTS_RECIPIENT_STATE_UPDATE:
      newState.data.lists = action.updatedRecipientListsState;
      return newState;
    case ASSET_AUDIENCE.LISTS_FAIL:
      newState.lists_loading = false;
      return newState;

    // actions related to asset contacts
    case ASSET_AUDIENCE.CONTACTS_LOAD:
      newState.contacts_loading = true;
      if (action.reset === true) newState.data.contacts = [];
      return newState;
    case ASSET_AUDIENCE.CONTACTS_SEARCH_SUCCESS:
      newState.data.contacts = [...action.payload.contacts];
      newState.contacts_loading = false;
      return newState;
    case ASSET_AUDIENCE.RESET_SEARCH_CONTACTS:
      newState.data.recipientContacts = [];
      newState.pageSearch = 0;
      return newState;
    case ASSET_AUDIENCE.RECIPIENT_SEARCH_SUCCESS:
      if (newState.pageSearch === 0) newState.data.recipientContacts = [...action.payload.contacts];
      else newState.data.recipientContacts = [...state.data.recipientContacts, ...action.payload.contacts];
      newState.pageSearch += 1;
      if (action.payload.contacts.length < 22) newState.hasMoreSearch = false;
      else newState.hasMoreSearch = true;
      newState.contacts_loading = false;
      return newState;
    case ASSET_AUDIENCE.CONTACTS_SUCCESS:
      newState.data.contacts = [...state.data.contacts, ...action.payload.contacts];
      newState.loadAllContacts = false;
      newState.page += 1;
      if (action.payload.contactsCount || action.payload.contactsCount === 0) {
        if (action.payload.isAddContacts) {
          newState.totalContacts += action.payload.contactsCount;
        } else {
          newState.totalContacts = action.payload.contactsCount;
        }
      }
      if (action.payload.contacts.length < 22) newState.hasMore = false;
      else newState.hasMore = true;
      newState.contacts_loading = false;
      return newState;
    case ASSET_AUDIENCE.CONTACTS_RECIPIENT_STATE_UPDATE:
      newState.data.contacts = action.updatedRecipientContactsState;
      return newState;
    case ASSET_AUDIENCE.ERROR_SEARCH_TERM:
      newState.success = action.payload.success;
      newState.message = action.payload.message;
      return newState;
    case ASSET_AUDIENCE.ERROR_SEARCH_TERM_LOADING:
      newState.contacts_loading = false;
      return newState;
    case ASSET_AUDIENCE.CONTACTS_FAIL:
      newState.contacts_loading = false;
      return newState;
    case ASSET_AUDIENCE.CONTACTS_UPDATE_ACTIVE_STATE:
      const { listId, contactId, activeState } = action.payload;
      if (listId !== '') {
        newState.data.lists.map((list: any) => {
          if (list.id.toString() === listId) {
            list.is_active = activeState;
          }
        });
      } else {
        newState.data.contacts.map((contact: any) => {
          if (contact.id.toString() === contactId) {
            contact.is_active = activeState;
          }
        });
      }

      return newState;

    case ASSET_AUDIENCE.UPDATE_CONTACT_SUCCESS:
      if (action.updateContact) {
        const { company_website, contact_email, contact_id, contact_name, designation, organization } =
          action.updateContact;

        newState.data.contacts.map((contact: any) => {
          if (contact.id === contact_id) {
            contact.email = contact_email;
            contact.name = contact_name;
            contact.designation = designation;
            contact.organization = organization;
          }
        });
      }

      return newState;

    case ASSET_AUDIENCE.REMOVE_CONTACT_SUCCESS:
      const contact_id = action.payload;
      const newContactsArray = newState.data.contacts.filter((contact: any) => contact.id !== contact_id);
      newState.data.contacts = newContactsArray;
      return newState;

    case ASSET_AUDIENCE.RESET:
      const defaultState = {
        data: {
          lists: Array<Interfaces.IListItem>(),
          contacts: Array<Interfaces.IContactItem>(),
          recipientContacts: Array<Interfaces.IContactItem>(),
        },
        lists_loading: false,
        contacts_loading: false,
        page: 0,
        hasMore: true,
        pageSearch: 0,
        hasMoreSearch: true,
        success: true,
        message: '',
      };
      return defaultState;

    case ASSET_AUDIENCE.CAMPAIGN_AUDIENCE_ALL_LISTS_DISABLED:
      newState.data.lists = newState.data.lists.map((list: any) => {
        list.disabled = action.payload;
        return list;
      });
      return newState;

    case ASSET_AUDIENCE.CAMPAIGN_AUDIENCE_ALL_CONTACTS_DISABLED:
      newState.data.contacts = newState.data.contacts.map((contact: any) => {
        contact.disabled = action.payload;
        return contact;
      });
      return newState;

    case ASSET_AUDIENCE.CAMPAIGN_AUDIENCE_LIST_DISABLED:
      newState.data.lists = newState.data.lists.map((list: any) => {
        if (list.id === action.payload) {
          list.disabled = !list.disabled;
        }
        return list;
      });
      return newState;

    case ASSET_AUDIENCE.CAMPAIGN_AUDIENCE_CONTACT_DISABLED:
      newState.data.contacts = newState.data.contacts.map((contact: any) => {
        if (contact.id === action.payload) {
          contact.disabled = !contact.disabled;
        }
        return contact;
      });
      return newState;
    case ASSET_AUDIENCE.UNLINK_AUDIENCE_SUCCESS:
      const contactsToRemove = action.payload.contactIds;
      const listsToRemove = action.payload.listIds;
      if (contactsToRemove?.length) {
        newState.totalContacts = newState.totalContacts - contactsToRemove.length;
        newState.data.contacts = newState.data.contacts.filter(
          (contact: any) => !contactsToRemove?.includes(contact.id),
        );
      }
      if (listsToRemove?.length) {
        newState.data.lists = newState.data.lists.filter((list: any) => !listsToRemove?.includes(list.id));
      }
      return newState;
    case ASSET_AUDIENCE.LOAD_ALL_CONTACTS: {
      newState.loadAllContacts = true;
      return newState;
    }
    default:
      return state;
  }
};

export const peopleAudienceReducer = (state = peopleAudienceInitialState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    //Filters
    case PEOPLE_AUDIENCE.SET_FILTERS:
      newState.filters = action.payload;
      return newState;

    case PEOPLE_AUDIENCE.UPDATE_TOTAL_COUNT_ON_CREATE_CONTACT:
      newState.totalCount = newState.totalCount + 1;
      return newState;

    ///All people
    case PEOPLE_AUDIENCE.LISTS_LOAD_ALL_PEOPLE:
      newState.allPeopleLoading = true;
      // newState.totalCount = 0;
      return newState;

    case PEOPLE_AUDIENCE.TOTAL_COUNT_UPDATE_ON_DELETE_ALL:
      const contactsAlreadyInList = newState.allPeople.filter((item) => item.is_list_contact);
      action.payload.addPeopleMode
        ? (newState.totalCount = action.payload.unselectedIds + contactsAlreadyInList.length)
        : (newState.totalCount = action.payload.unselectedIds);
      const tab = action.payload.tab;

      if (tab === 'all') {
        // rest profiled
        newState.profilePage = 0;
        newState.profiledPeopleloading = false;
        newState.profiledPeople = [];
        newState.profilePagePagination = true;
        // reset unprofiled
        newState.unprofiledPage = 0;
        newState.unprofiledPeopleloading = false;
        newState.nonprofiledPeople = [];
        newState.unprofiledPagePagination = true;
      }

      if (tab === 'profiled') {
        //reset all people
        newState.allPeoplePage = 0;
        newState.allPeopleLoading = false;
        newState.allPeople = [];
        newState.allPeoplePagePagination = true;
        // reset unprofiled
        newState.unprofiledPage = 0;
        newState.unprofiledPeopleloading = false;
        newState.nonprofiledPeople = [];
        newState.unprofiledPagePagination = true;
      }

      if (tab === 'unprofiled') {
        //reset all people
        newState.allPeoplePage = 0;
        newState.allPeopleLoading = false;
        newState.allPeople = [];
        newState.allPeoplePagePagination = true;
        // rest profiled
        newState.profilePage = 0;
        newState.profiledPeopleloading = false;
        newState.profiledPeople = [];
        newState.profilePagePagination = true;
      }

      return newState;

    case PEOPLE_AUDIENCE.LISTS_SUCCESS_ALL_PEOPLE:
      newState.allPeopleLoading = false;
      if (action.totalCount !== undefined) newState.totalCount = action.totalCount;
      if (action.totalCountWithoutList !== undefined) {
        newState.totalCountWithoutList = action.totalCountWithoutList;
      }
      newState.allPeople = [...newState.allPeople, ...action.payload];
      newState.allPeoplePage = newState.allPeoplePage + 1;
      if (newState.allPeoplePage > 1 && action.payload.length === 0) {
        newState.allPeoplePagePagination = false;
      }
      if (action.payload.length < 10) {
        newState.allPeoplePagePagination = false;
      }
      return newState;

    case PEOPLE_AUDIENCE.LISTS_SUCCESS_ALL_PEOPLE_SEARCH:
      newState.allPeopleLoading = false;
      if (action.totalCount !== undefined) newState.totalCount = action.totalCount;
      if (action.totalCountWithoutList !== undefined) {
        newState.totalCountWithoutList = action.totalCountWithoutList;
      }
      newState.allPeople = [...newState.allPeople, ...action.payload];
      newState.allPeoplePage = newState.allPeoplePage + 1;
      return newState;

    case PEOPLE_AUDIENCE.ERROR_SEARCH_TERM:
      newState.success = action.payload.success;
      newState.message = action.payload.message;
      return newState;

    case PEOPLE_AUDIENCE.ERROR_SEARCH_TERM_LOADING:
      newState.allPeopleLoading = false;
      return newState;

    case PEOPLE_AUDIENCE.LISTS_FAIL_ALL_PEOPLE:
      const errMessageCheckAllPeople = action.message === 'Operation canceled due to new request.' ? true : false;
      if (!errMessageCheckAllPeople) newState.allPeopleLoading = false;
      return newState;

    case PEOPLE_AUDIENCE.LISTS_LOAD_ALL_PEOPLE_RESET:
      newState.allPeoplePage = 0;
      // newState.allPeopleLoading = false;
      newState.allPeople = [];
      newState.allPeoplePagePagination = true;
      newState.totalCount = 0;
      return newState;

    ////Profiled
    case PEOPLE_AUDIENCE.LISTS_LOAD_PROFILED:
      newState.profiledPeopleloading = true;
      // newState.totalCount = 0;
      return newState;

    case PEOPLE_AUDIENCE.LISTS_SUCCESS_PROFILED:
      newState.profiledPeopleloading = false;
      newState.totalCount = action.totalCount;
      newState.profiledPeople = [...newState.profiledPeople, ...action.payload];
      newState.profilePage = newState.profilePage + 1;
      if (newState.profilePage > 1 && action.payload.length === 0) {
        newState.profilePagePagination = false;
      }
      if (action.payload.length < 10) {
        newState.profilePagePagination = false;
      }
      return newState;

    case PEOPLE_AUDIENCE.LISTS_SUCCESS_PROFILED_SEARCH:
      newState.profiledPeopleloading = false;
      newState.totalCount = action.totalCount;
      newState.profiledPeople = [...newState.profiledPeople, ...action.payload];
      newState.profilePage += 1;
      return newState;

    case PEOPLE_AUDIENCE.LISTS_FAIL_PROFILED:
      const errMessageCheckProfiledPeople = action.message === 'Operation canceled due to new request.' ? true : false;
      if (!errMessageCheckProfiledPeople) newState.profiledPeopleloading = false;
      return newState;

    case PEOPLE_AUDIENCE.LISTS_LOAD_PROFILED_RESET:
      newState.profilePage = 0;
      // newState.profiledPeopleloading = false;
      newState.profiledPeople = [];
      newState.profilePagePagination = true;
      newState.totalCount = 0;
      return newState;

    //Unprofiled Poeple
    case PEOPLE_AUDIENCE.LISTS_LOAD_UNPROFILED_RESET:
      newState.unprofiledPage = 0;
      // newState.unprofiledPeopleloading = false;
      newState.nonprofiledPeople = [];
      newState.unprofiledPagePagination = true;
      newState.totalCount = 0;
      return newState;

    case PEOPLE_AUDIENCE.LISTS_LOAD_UNPROFILED:
      newState.unprofiledPeopleloading = true;
      // newState.totalCount = 0;
      return newState;

    case PEOPLE_AUDIENCE.LISTS_SUCCESS_UNPROFILED:
      newState.unprofiledPeopleloading = false;
      newState.totalCount = action.totalCount;
      newState.nonprofiledPeople = [...newState.nonprofiledPeople, ...action.payload];
      newState.unprofiledPage = newState.unprofiledPage + 1;
      if (newState.unprofiledPage > 1 && action.payload.length === 0) {
        newState.unprofiledPagePagination = false;
      }
      if (action.payload.length < 10) {
        newState.unprofiledPagePagination = false;
      }
      return newState;

    case PEOPLE_AUDIENCE.LISTS_SUCCESS_UNPROFILED_SEARCH:
      newState.unprofiledPeopleloading = false;
      newState.totalCount = action.totalCount;
      newState.nonprofiledPeople = [...newState.nonprofiledPeople, ...action.payload];
      newState.unprofiledPage = newState.unprofiledPage + 1;
      return newState;

    case PEOPLE_AUDIENCE.LISTS_FAIL_UNPROFILED:
      const errMessageCheckUnprofiledPeople =
        action.message === 'Operation canceled due to new request.' ? true : false;
      if (!errMessageCheckUnprofiledPeople) newState.unprofiledPeopleloading = false;
      return newState;

    //Contact details
    case AUDIENCE_CONTACT_DETAILS.LOAD:
      newState.contactDetails = action.payload;
      return newState;

    case AUDIENCE_CONTACT_DETAILS.SUCCESS:
      newState.contactDetails = action.payload;
      return newState;

    case AUDIENCE_CONTACT_DETAILS.RESET:
      newState.contactDetails = action.payload;
      return newState;

    case PEOPLE_AUDIENCE.CREATE_NEW_CONTACT_LOAD:
      newState.createNewContactLoading = true;
      return newState;

    case PEOPLE_AUDIENCE.CREATE_NEW_CONTACT_LOAD_SUCCESS:
      newState.createNewContactLoading = false;
      if (action.payload.profiled === 'profiled') {
        newState.profiledPeople = [action.payload.newContact, ...newState.profiledPeople];
        if (!action.payload.isProfiled) newState.removeUnprofiledFromProfiled = true;
      } else if (action.payload.profiled === 'unprofiled') {
        let newContact = {
          ...action.payload.newContact,
          personality:
            action.payload.isProfiled && !action.payload.newContact.personality
              ? 'Steady'
              : action.payload.newContact.personality,
        };
        newState.nonprofiledPeople = [newContact, ...newState.nonprofiledPeople];
        if (action.payload.isProfiled) newState.removeProfiledFromUnprofiled = true;
      }
      newState.createNewContactStatus = true;
      newState.newlyAddedContact = action.payload.newContact.contact_id;
      //* resetting all people to reload
      if (action.payload.profiled === 'all') {
        newState.allPeople = [action.payload.newContact, ...newState.allPeople];
      } else {
        newState.allPeople = Array<Interfaces.IPeopleItem>();
      }
      return newState;

    case PEOPLE_AUDIENCE.NEWLY_ADDED_CONTACT_UPDATE:
      newState.newlyAddedContact = action.payload.contact_id;
      return newState;

    case PEOPLE_AUDIENCE.RESET_CREATE_CONTACT_LOADER:
      newState.createNewContactLoading = false;
      return newState;

    case PEOPLE_AUDIENCE.CREATE_NEW_CONTACT_ADDED_WITH_FILTER_SUCCESS:
      newState.createNewContactLoading = false;
      newState.createNewContactStatus = true;
      return newState;

    case PEOPLE_AUDIENCE.CREATE_NEW_CONTACT_UPDATE_SUCCESS:
      newState.createNewContactLoading = false;
      let index = newState.allPeople.findIndex(
        (item) => item.contact_id.toString() === action.payload.updatedContact.contact_id.toString(),
      );
      if (index >= 0) {
        newState.allPeople[index] = { ...action.payload.updatedContact };
      }
      newState.createNewContactStatus = true;
      newState.newlyAddedContact = action.payload.updatedContact.contact_id;
      newState.contactUpdatedInPeopleAudience = true;
      return newState;

    case PEOPLE_AUDIENCE.RESET_CONTACT_UPDATE_FLAG:
      newState.contactUpdatedInPeopleAudience = false;
      return newState;

    case PEOPLE_AUDIENCE.NEW_CONTACT_CREATED_WITH_FILTERS:
      newState.createNewContactStatus = true;
      return newState;

    case PEOPLE_AUDIENCE.CREATE_NEW_CONTACT_RESET_FORM:
      newState.createNewContactStatus = false;
      newState.newlyAddedContact = '';
      return newState;

    case PEOPLE_AUDIENCE.DELETE_SELECTED_CONTACT_LOAD:
      newState.deleteLoading = true;
      return newState;

    case PEOPLE_AUDIENCE.DELETE_SELECTED_CONTACT_RESET:
      newState.deleteSuccess = false;
      return newState;

    case PEOPLE_AUDIENCE.DELETE_SELECTED_CONTACT_FAIL:
      newState.deleteLoading = false;
      return newState;

    case PEOPLE_AUDIENCE.DELETE_ALL_SELECTED_CONTACT_SUCCESS: // case for deleting contacts when delete all is true
      newState.deleteLoading = false;
      newState.deleteSuccess = true;
      // if (action.payload.tab === "all") {
      const tempArrayAllPeople = newState.allPeople.filter((item) =>
        action.payload.unselectedIds?.includes(item.contact_id),
      );
      newState.allPeople.filter((item) => item.is_list_contact);
      const contactsExistsInList = newState.allPeople.filter((item) => item.is_list_contact);
      console.info([...tempArrayAllPeople, contactsExistsInList]);
      action.payload.addPeopleMode
        ? (newState.allPeople = [...tempArrayAllPeople, ...contactsExistsInList])
        : (newState.allPeople = [...tempArrayAllPeople]);
      // } else if (action.payload.tab === "profiled") {
      const tempArrayProfiledPeople = newState.profiledPeople.filter((item) =>
        action.payload.unselectedIds?.includes(item.contact_id),
      );
      newState.profiledPeople = [...tempArrayProfiledPeople];
      // } else {
      const tempArrayUnProfiledPeople = newState.nonprofiledPeople.filter((item) =>
        action.payload.unselectedIds?.includes(item.contact_id),
      );
      newState.nonprofiledPeople = [...tempArrayUnProfiledPeople];
      // }
      newState.totalCount = newState.totalCount - action.payload?.unselectedIds.length;

      return newState;

    case PEOPLE_AUDIENCE.DELETE_SELECTED_CONTACT_SUCCESS: // case for deleting contacts when delete all is false
      newState.deleteLoading = false;
      newState.deleteSuccess = true;
      // if (action.payload.tab === "all") {
      const newArrayAllPeople = newState.allPeople.filter(
        (item) => !action.payload.selectedIds?.includes(item.contact_id),
      );
      newState.allPeople = [...newArrayAllPeople];
      // } else if (action.payload.tab === "profiled") {
      const newArrayProfiledPeople = newState.profiledPeople.filter(
        (item) => !action.payload.selectedIds?.includes(item.contact_id),
      );
      newState.profiledPeople = [...newArrayProfiledPeople];
      // } else {
      const newArrayUnProfiledPeople = newState.nonprofiledPeople.filter(
        (item) => !action.payload.selectedIds?.includes(item.contact_id),
      );
      newState.nonprofiledPeople = [...newArrayUnProfiledPeople];
      // }
      newState.totalCount = newState.totalCount - action.payload?.selectedIds.length;
      return newState;

    case PEOPLE_AUDIENCE.LISTS_REMOVE_PROFILED_FROM_UNPROFILED:
      newState.nonprofiledPeople = newState.nonprofiledPeople.filter((item) => !item.personality);
      newState.removeProfiledFromUnprofiled = false;
      return newState;

    case PEOPLE_AUDIENCE.RESET_TOTAL_COUNT:
      newState.totalCount = 0;
      return newState;

    case PEOPLE_AUDIENCE.LISTS_REMOVE_UNPROFILED_FROM_PROFILED:
      newState.profiledPeople = newState.profiledPeople.filter((item) => item.personality);
      newState.removeUnprofiledFromProfiled = false;
      return newState;

    case PEOPLE_AUDIENCE.CREATE_NEW_CONTACT_LOAD_FAIL:
      newState.createNewContactLoading = false;
      return newState;

    case PEOPLE_AUDIENCE.UPDATE_CONTACT_EXISTS_IN_LIST_STATE:
      newState.allPeople = newState.allPeople.map((contact: any) => {
        if (action.selectedContacts.includes(contact.contact_id)) {
          return { ...contact, is_list_contact: !contact.is_list_contact };
        }
        return contact;
      });
      // if added to list from global list it will decrease the count
      newState.totalCountWithoutList =
        newState.totalCountWithoutList +
        (action.fromGlobal ? -action.selectedContacts.length : action.selectedContacts.length);
      return newState;

    case AUDIENCE_CONTACT_DASHBOARD.LOAD:
      newState.contactDashboard = action.payload;
      return newState;
    case AUDIENCE_CONTACT_DASHBOARD.SUCCESS:
      newState.contactDashboard = action.payload;
      return newState;
    case AUDIENCE_CONTACT_DASHBOARD.SUCCESS:
      newState.contactDashboard = action.payload;
      return newState;
    case AUDIENCE_CONTACT_SUBSCRIPTIONS.LOAD:
      newState.contactSubscriptions = action.payload;
      return newState;
    case AUDIENCE_CONTACT_SUBSCRIPTIONS.SUCCESS:
      newState.contactSubscriptions = action.payload;
      return newState;
    case AUDIENCE_CONTACT_SUBSCRIPTIONS.FAIL:
      newState.contactSubscriptions = { ...newState.contactSubscriptions, ...action.payload };
      return newState;
    case AUDIENCE_CONTACT_ENGAGEMENT.LOAD:
      newState.contactEngagement = action.payload;
      return newState;
    case AUDIENCE_CONTACT_ENGAGEMENT.SUCCESS:
      newState.contactEngagement = action.payload;
      return newState;
    case AUDIENCE_CONTACT_SIMILAR.LOAD:
      newState.contactSimilar = action.payload;
      return newState;
    case AUDIENCE_CONTACT_SIMILAR.SUCCESS:
      newState.contactSimilar = action.payload;
      return newState;
    case AUDIENCE_REMOVE_RECOMMENDED.ASSET:
      newState?.contactDashboard?.assets?.splice(action.payload, 1);
      return newState;
    case AUDIENCE_REMOVE_RECOMMENDED.CAMPAIGN:
      newState?.contactDashboard?.campaigns?.splice(action.payload, 1);
      return newState;
    case AUDIENCE_REMOVE_RECOMMENDED.LIST:
      newState?.contactDashboard?.lists?.splice(action.payload, 1);
      return newState;
    case AUDIENCE_REMOVE_SUBSCRIBED.ASSET:
      newState?.contactSubscriptions?.subscribed_assets?.splice(action.payload, 1);
      newState.uiUpdateCheck = !newState.uiUpdateCheck;
      return newState;
    case AUDIENCE_REMOVE_SUBSCRIBED.CAMPAIGN:
      newState?.contactSubscriptions?.subscribed_campaigns?.splice(action.payload, 1);
      newState.uiUpdateCheck = !newState.uiUpdateCheck;
      return newState;
    case AUDIENCE_REMOVE_SUBSCRIBED.LIST:
      newState?.contactSubscriptions?.subscribed_lists?.splice(action.payload, 1);
      newState.uiUpdateCheck = !newState.uiUpdateCheck;
      return newState;
    case AUDIENCE_PEOPLE.SEARCH:
      newState.searchTermPeople = action.payload;
      return newState;
    case AUDIENCE_PEOPLE.RESET:
      newState.searchTermPeople = '';
      if (action.payload.profiled) {
        newState.profiledPeople = [];
        newState.profilePage = 0;
      } else {
        newState.unprofiledPage = 0;
        newState.nonprofiledPeople = [];
      }
      return newState;
    case AUDIENCE_PEOPLE.CLEAR:
      newState.searchTermPeople = '';
      return newState;
    case PEOPLE_AUDIENCE.SET_RELOAD:
      newState.reloadContacts = action.payload;
      return newState;

    case PEOPLE_AUDIENCE.UPDATE_CONTACT_SUCCESS:
      const { company_website, contact_email, contact_id, contact_name, designation, organization } = action.payload;

      newState.allPeople.map((contact: any) => {
        if (contact.contact_id === contact_id) {
          contact.contact_email = contact_email;
          contact.contact_name = contact_name;
          contact.company_website = company_website;
          contact.designation = designation;
          contact.organization = organization;
        }
      });
      newState.profiledPeople.map((contact: any) => {
        if (contact.contact_id === contact_id) {
          contact.contact_email = contact_email;
          contact.contact_name = contact_name;
          contact.company_website = company_website;
          contact.designation = designation;
          contact.organization = organization;
        }
      });
      newState.nonprofiledPeople.map((contact: any) => {
        if (contact.contact_id === contact_id) {
          contact.contact_email = contact_email;
          contact.contact_name = contact_name;
          contact.company_website = company_website;
          contact.designation = designation;
          contact.organization = organization;
        }
      });
      newState.updateContactInProgress = false;
      newState.contactUpdatedSuccessfully = true;
      newState.contactUpdateFailed = false;
      newState.peopleUiRerenderCheck = !newState.peopleUiRerenderCheck;
      return newState;

    case PEOPLE_AUDIENCE.UPDATE_CONTACT_CALL_IN_PROGRESS:
      newState.updateContactInProgress = true;
      newState.contactUpdatedSuccessfully = false;
      newState.contactUpdateFailed = false;
      return newState;

    case PEOPLE_AUDIENCE.UPDATE_CONTACT_FAIL:
      newState.updateContactInProgress = false;
      newState.contactUpdatedSuccessfully = false;
      newState.contactUpdateFailed = true;
      return newState;

    case PEOPLE_AUDIENCE.RESET_EDIT_CONTACT:
      newState.contactUpdatedSuccessfully = false;
      newState.contactUpdateFailed = false;
      newState.createNewContactLoading = false;
      newState.updateContactInProgress = false;
      return newState;

    case PEOPLE_AUDIENCE.OPEN_EDIT_CONTACT_SIDEBAR:
      newState.openEditContactSidebar = true;
      return newState;

    case PEOPLE_AUDIENCE.CLOSE_EDIT_CONTACT_SIDEBAR:
      newState.openEditContactSidebar = false;
      return newState;

    case PEOPLE_AUDIENCE.SELECTED_PEROSNALITY_TYPES:
      newState.selectedPersonalityTypes = action.payload;
      return newState;

    case AUDIENCE_PEOPLE.ORGANIZATIONS:
      newState.organizations = action.payload;
      newState.organizationsLoading = false;
      return newState;
    case AUDIENCE_PEOPLE.DESIGNATIONS:
      newState.designations = action.payload;
      newState.designationsLoading = false;
      return newState;
    case AUDIENCE_PEOPLE.LOADING_ORGANIZATIONS:
      newState.organizations = [];
      newState.organizationsLoading = true;
      return newState;
    case AUDIENCE_PEOPLE.LOADING_DESIGNATIONS:
      newState.designations = [];
      newState.designationsLoading = true;
      return newState;
    case AUDIENCE_PEOPLE.ORGANIZATIONS_FAIL:
      newState.organizations = [];
      newState.organizationsLoading = false;
      return newState;
    case AUDIENCE_PEOPLE.DESIGNATIONS_FAIL:
      newState.designations = [];
      newState.designationsLoading = false;
      return newState;
    case AUDIENCE_PEOPLE.ORGANIZATIONS_UPDATE:
      if (!newState.organizations.find((item: any) => item.name === action.organization?.name?.trim()))
        newState.organizations = [action.organization, ...newState.organizations];
      return newState;
    case AUDIENCE_PEOPLE.DESIGNATIONS_UPDATE:
      if (!newState.designations.find((item: any) => item.name === action.designation?.name?.trim()))
        newState.designations = [action.designation, ...newState.designations];
      return newState;
    case AUDIENCE_PEOPLE.ORGANIZATIONS_RESET:
      newState.organizations = [];
      newState.organizationsLoading = false;
      return newState;
    case AUDIENCE_PEOPLE.DESIGNATIONS_RESET:
      newState.designations = [];
      newState.designationsLoading = false;
      return newState;
    case PEOPLE_AUDIENCE.EXPORT_FILTER_PEOPLE_AUDIENCE:
      newState.peopleAudienceFilters = action.payload;
      return newState;

    case PEOPLE_AUDIENCE.SET_CURRENT_ACTIVE_LIST:
      newState.currentActiveList = action.payload;
      return newState;

    case PEOPLE_AUDIENCE.ADD_CONTACTS_TO_GLOBAL_LIST:
      newState.allPeople = [action.addedContact, ...newState.allPeople];
      newState.totalCount = newState.totalCount + 1;
      newState.totalCountWithoutList = newState.totalCountWithoutList + 1;
      return newState;

    default:
      return state;
  }
};

export const searchRecommendedPeopleReducer = (
  state = searchRecommendedPeopleInitialState,
  action: Interfaces.IRecommendedPeopleSearch,
) => {
  const newState = { ...state };
  switch (action.type) {
    case RECOMMENDED_PEOPLE_SEARCH.LOAD:
      newState.loading = true;
      return newState;
    case RECOMMENDED_PEOPLE_SEARCH.SUCCESS:
      newState.data = [...newState.data, ...action.payload];
      newState.loading = false;
      newState.totalSearchedContacts = action.offset === 0 ? action.totalContacts : newState.totalSearchedContacts;
      return newState;
    case RECOMMENDED_PEOPLE_SEARCH.ERROR_SEARCH_TERM:
      newState.success = action.success;
      newState.message = action.message;
      return newState;
    case RECOMMENDED_PEOPLE_SEARCH.ERROR_SEARCH_TERM_LOADING:
      newState.loading = false;
      return newState;
    case RECOMMENDED_PEOPLE_SEARCH.FAIL:
      newState.loading = false;
      return newState;
    case RECOMMENDED_PEOPLE_SEARCH.CLEAR:
      newState.loading = false;
      newState.data = new Array<Interfaces.IContactItem>();
      return newState;
    case RECOMMENDED_PEOPLE_SEARCH.CLEAR_DATA:
      newState.data = new Array<Interfaces.IContactItem>();
      return newState;

    default:
      return state;
  }
};

export const searchRecommendedListReducer = (
  state = searchRecommendedListInitialState,
  action: Interfaces.IRecommendedListSearch,
) => {
  const newState = { ...state };
  switch (action.type) {
    case RECOMMENDED_LIST_SEARCH.LOAD:
      newState.loading = true;
      return newState;
    case RECOMMENDED_LIST_SEARCH.SUCCESS:
      newState.data = [...newState.data, ...action.payload];
      newState.loading = false;
      newState.totalLists = action.totalLists;
      return newState;
    case RECOMMENDED_LIST_SEARCH.ERROR_SEARCH_TERM:
      newState.success = action.success;
      newState.message = action.message;
      return newState;
    case RECOMMENDED_LIST_SEARCH.ERROR_SEARCH_TERM_LOADING:
      newState.loading = false;
      return newState;
    case RECOMMENDED_LIST_SEARCH.FAIL:
      newState.loading = false;
      return newState;
    case RECOMMENDED_LIST_SEARCH.CLEAR:
      newState.loading = false;
      newState.data = new Array<Interfaces.IListItem>();
      return newState;
    case RECOMMENDED_LIST_SEARCH.CLEAR_DATA:
      newState.data = new Array<Interfaces.IListItem>();
      return newState;

    default:
      return state;
  }
};

const initialSuggestedEmailsState = { suggestedContacts: [] as any[], loading: false, message: '' };

export const suggestedEmailsReducer = (state = initialSuggestedEmailsState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case SUGGESTED_EMAILS.SUCCESS:
      newState.suggestedContacts = action.payload;
      newState.loading = false;
      return newState;

    case SUGGESTED_EMAILS.LOAD:
      newState.loading = action.payload;
      return newState;

    case SUGGESTED_EMAILS.ERROR_SEARCH_TERM:
      newState.loading = false;
      newState.message = action.payload.message;
      return newState;

    default:
      return state;
  }
};

const viewRecipientInitialState = { total_recipients: <number | string>0, loading: false, is_search: false };

export const viewRecipientsReducer = (state = viewRecipientInitialState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case VIEW_RECIPIENTS.LOAD:
      newState.loading = true;
      return newState;
    case VIEW_RECIPIENTS.SUCCESS:
      newState.total_recipients = action.payload;
      newState.loading = false;
      return newState;
    case VIEW_RECIPIENTS.FAIL:
      newState.total_recipients = 'fetching failed';
      newState.loading = false;
      return newState;
    case VIEW_RECIPIENTS.SET_IS_SEARCH:
      newState.is_search = action.payload;
      return newState;

    default:
      return state;
  }
};
